/**
 * Created by fwt on 2018/8/20.
 */
import React,{Component} from 'react';
import "./style.less"
import {allInvoiceDetail,invoiceBack} from "../../../service/invoiceService";
import { ListView, Modal, NavBar,Icon,Toast} from "antd-mobile";
import moment from 'moment';
import connect from "react-redux/es/connect/connect";
let pageIndex = 1;
let pageSize = 10;
const notInvoice = require('../../../common/image/noInvoice.png');
const dataError = require('../../../common/image/wrongData.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InvoiceHistory extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state={
            data:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
        }
    }
    componentDidMount() {
        pageIndex = 1;
        let params={
            source:6,
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            },
        };
        this.initData(params);
    }
    initData(params){
        allInvoiceDetail(params).then(res=>{
            console.log(res)
            if(res.data.code == "0000"){
                if (res.data.data.list.length > 0) {
                    this._setDataSource(res.data.data);
                    // this.setState({data:res.data.data.list})
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else {
                this.setState({notDataLoading:2,isLoading: false});
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                source:6,
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this.initData(params);
        }
    };
    backInvoice(item){
        Toast.loading('',0);
        let params = {
            source:6,
            token: this.props.userInfo.token,
            data: {id:item.id}
        };
        invoiceBack(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("撤回成功",2,()=>window.location.reload());
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={notInvoice} />
                        <p>暂无开票历史</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    reback(i){
        if(i.status == 0 && i.receiveType == 2 && i.invoiceType == 1){
            return <div className="back" onClick={(e)=>{e.stopPropagation();
                        Modal.alert('提示', '您确定要撤回吗?', [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice(i)},
                        ])}}>撤回</div>
        } 
        if(i.status == 0 && i.invoiceType == 0){
            return <div className="back" onClick={(e)=>{e.stopPropagation();
                        Modal.alert('提示', '您确定要撤回吗?', [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice(i)},
                        ])}}>撤回</div>
        } 
    }
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="invoiceBox"  key={rowID} onClick={() =>{console.log(i) ;this.props.history.push(`/paperInvoice/${i.id}`,{id:i.id})}}>
                <div className="time">
                    <span className="timeText">预约出行</span>
                    <span className="colorGray">{i.status == 0 ? '待开票' : i.status == 1?'已开票':i.status == 999?'已作废':''}</span>
                </div>
                <div className="invoiceTime">
                    <div>
                        <div>申请时间</div>
                        <span>{moment(i.applyTime).format('YYYY-MM-DD hh:mm:ss')}</span>
                    </div>
                    <div>
                        <div>开票类型</div>
                        <span>{i.invoiceType == 0 ? '电子发票' : '纸质发票'}</span> <span  style={{paddingLeft:10}}>{i.receiveType == 2 ? '自提' : '邮寄'}</span>
                    </div>
                    <div>
                        <div>开票金额</div>
                        <span className="colorOrange">{'¥'+i.invoiceAmountAvailable}</span>
                        { this.reback(i) }
                    </div>
                </div>
            </div>
        );
        return (
            <div className="invoiceHistory">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >开票历史</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                className="invoiceList"
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow: 'auto',
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }

                </div>

                


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceHistory/index.js